import { render } from "./BookingDisclaimer.vue?vue&type=template&id=14c7c520&scoped=true&ts=true"
import script from "./BookingDisclaimer.vue?vue&type=script&lang=ts"
export * from "./BookingDisclaimer.vue?vue&type=script&lang=ts"

import "./BookingDisclaimer.vue?vue&type=style&index=0&id=14c7c520&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c7c520"]])

export default __exports__